export default __webpack_public_path__ + "static/media/enrolment-email-icon.390e09f9.svg";